/// <amd-module name="Dashboards/DashboardPanel/CopyDashboardPanel" />
import { CopyDashboardOptions, CopyDashboardResponse, Dashboard as ServerDashboard, DashboardScope} from "Dashboards/Common/Contracts/Dashboard";
import { TeamContext } from "Dashboards/Common/Contracts/TeamContext";
import { IDashboardRestClient } from "Dashboards/Common/RestClient/Dashboard";
import {
    Constants,
    FormFields,
    Project,
    Team,
    DashboardType,
    TeamProjectItem
} from "Dashboards/DashboardPanel/Common";
import { DashboardPanel } from "Dashboards/DashboardPanel/DashboardPanel";
import * as Resources from "Dashboards/DashboardPanel/Resources";
import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";

export interface CopyDashboardPanelProps {
    onDashboardCopied: (copiedDashboard: Pick<TeamContext & ServerDashboard, "id" | "teamId" | "projectId" | "dashboardScope">) => void;
    onLoadNewTeamsForProject: (project: Project) => void;
    onDismiss: () => void;
    project: Project;
    projects: Project[];
    dashboard: ServerDashboard;
    team: Team;
    projectTeamMap: {[id:string]:TeamProjectItem};
    useDedicatedApi: boolean;
}

export class CopyDashboardPanel extends VssComponent<CopyDashboardPanelProps> {

    public render(): JSX.Element {
        const {onDismiss, project, projects, projectTeamMap, team } = this.props;

        return (
            <DashboardPanel
                dashboardTeam={team}
                dashboardProject={project}
                allTeams={[]}
                onDismiss={onDismiss}
                onSubmit={this.handleSubmit}
                submitButtonLabel={Resources.CreateDashboardSubmitButtonLabel}
                title={Resources.CopyDashboardPanelTitle}
                userTeams={[]}
                showDashboardProjectTeamSelector={true}
                showQueryFolderSelector={true}
                projects={projects}
                projectTeamMap={projectTeamMap}
                onProjectSelectLoadTeam={this.props.onLoadNewTeamsForProject}
            >
            </DashboardPanel>
        );
    }

    private handleSubmit = (fields: FormFields, selectedDashboardType: DashboardType): Promise<void> => {
        return new Promise((resolve, reject) => {
            const dashboardRestClient = this.context.pageContext.getRestClient<IDashboardRestClient>("IDashboardRestClient");
            const targetTeamContext = {
                teamId: selectedDashboardType === DashboardType.Team ? fields.teamId! : null,
                projectId: fields.projectId,
                project: "",
                team: ""
            } as TeamContext;

            if (this.props.useDedicatedApi === true)
            {
                const sourceTeamContext = {
                    teamId: this.props.team && this.props.team.id ? this.props.team.id : "",
                    projectId: this.props.project && this.props.project.id? this.props.project.id : "",
                    project: "",
                    team: ""
                } as TeamContext;

                const copyDashboardOptions : CopyDashboardOptions = selectedDashboardType == DashboardType.Project ? {
                    copyDashboardScope:DashboardScope.Project,
                    projectId:fields.projectId ? fields.projectId : "",
                    teamId: "",
                    name: fields.name,
                    description: fields.description,
                    refreshInterval: fields.autoRefresh ? Constants.autoRefreshIntervalInMins : 0,
                    copyQueriesFlag: fields.copyQueriesFlag ? fields.copyQueriesFlag : false,
                    queryFolderPath: fields.queryFolderPath ? fields.queryFolderPath : Resources.SharedQueries
               
                } : 
                {
                    copyDashboardScope:DashboardScope.Project_Team,
                    projectId:fields.projectId ? fields.projectId : "",
                    teamId: fields.teamId ? fields.teamId : "",
                    name: fields.name,
                    description: fields.description,
                    refreshInterval: fields.autoRefresh ? Constants.autoRefreshIntervalInMins : 0,
                    copyQueriesFlag: fields.copyQueriesFlag ? fields.copyQueriesFlag : false,
                    queryFolderPath: fields.queryFolderPath ? fields.queryFolderPath : Resources.SharedQueries
               
                };

                dashboardRestClient
                    .copyDashboard(copyDashboardOptions, sourceTeamContext, this.props.dashboard.id)
                    .then((copyDashboardResponse: CopyDashboardResponse) => {
                        this.props.onDashboardCopied({
                            ...targetTeamContext,
                            ...copyDashboardResponse.copiedDashboard
                        })
                    })
                    .catch((error: Error) => {
                        reject(error);
                    });
            }
            else 
            {
                const newDashboard = {
                    ...this.props.dashboard,
                    name: fields.name,
                    id: "",
                    description: fields.description,
                    refreshInterval: fields.autoRefresh ? Constants.autoRefreshIntervalInMins : 0
                } as ServerDashboard;

                dashboardRestClient
                    .createDashboard(newDashboard, targetTeamContext)
                    .then((copiedDashboard: ServerDashboard) => {
                        this.props.onDashboardCopied({
                            ...targetTeamContext,
                            ...copiedDashboard
                        })
                    })
                    .catch((error: Error) => {
                        reject(error);
                    });
            }
        });
    };
}
